import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledHelpViewButton = styled(Button)(({ variant, theme }) => ({
  ...(variant === 'contained' && {
    backgroundColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
    },
  }),
}));
